import { useState } from "react";
import { fetchClaimVerificationTrace } from "../../../lib/internalClaimsApi";
import type { ClaimVerificationTraceResponse } from "../../../lib/internalClaimsApi";

interface UseClaimVerificationTraceResult {
  data: ClaimVerificationTraceResponse | null;
  isLoading: boolean;
  error: string | null;
  lookup: (claimId: string) => Promise<void>;
}

export function useClaimVerificationTrace(): UseClaimVerificationTraceResult {
  const [data, setData] = useState<ClaimVerificationTraceResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function lookup(claimId: string): Promise<void> {
    setIsLoading(true);
    setError(null);
    setData(null);
    try {
      const result = await fetchClaimVerificationTrace(claimId.trim());
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch trace");
    } finally {
      setIsLoading(false);
    }
  }

  return { data, isLoading, error, lookup };
}
